module.exports = __webpack_public_path__ + "res/img_other_action.fa7abf864d2506998caa49603cc89a94.png";